import { Component, OnInit } from '@angular/core';
import { ScenService } from '../../../../../../../scen.service';

@Component({
  selector: 'app-wrapper-panels',
  templateUrl: './wrapper-panels.component.html',
  styleUrls: ['./wrapper-panels.component.scss']
})
export class WrapperPanelsComponent implements OnInit {

  listProgram = false;
  editProgram = false;
  zeroRet = false;
  offset = false;
  mdi = false;
  ap = false; // tryb edit active program
  aProgram1 = true;

  constructor(public progService: ScenService) { }

  ngOnInit() {

    this.progService.getZML1().subscribe(data => {

      data === 'LIST PROGRAM' ? this.listProgram = true : this.listProgram = false;
      data === 'EDIT' ? this.editProgram = true : this.editProgram = false;
      (data === 'ZERO RET' || data === 'V' || data === '^') ? this.zeroRet = true : this.zeroRet = false;
      (data === 'MDI ' || data === 'V' || data === '^') ? this.mdi = true : this.mdi = false;
      data === 'OFFSET' ? this.offset = true : this.offset = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/wrapper-panels/wrapper-panels.component.ts